// Inter (replaces fonts.googleapis.com Inter link)
import "@fontsource/inter";          // 400
import "@fontsource/inter/500.css";  // 500
import "@fontsource/inter/600.css";  // 600
import "@fontsource/inter/700.css";  // 700

// Devanagari glyph fallback for Hindi content
import "@fontsource/noto-sans-devanagari";          // 400
import "@fontsource/noto-sans-devanagari/500.css";  // 500
import "@fontsource/noto-sans-devanagari/600.css";  // 600
import "@fontsource/noto-sans-devanagari/700.css";  // 700

// Sora — bundled locally so AI-generated react-viz code that references Sora
// resolves to this local copy instead of fetching from fonts.gstatic.com
import "@fontsource/sora";          // 400
import "@fontsource/sora/500.css";  // 500
import "@fontsource/sora/600.css";  // 600
import "@fontsource/sora/700.css";  // 700

// Open Sans (replaces fonts.googleapis.com Open Sans link)
import "@fontsource/open-sans";          // 400
import "@fontsource/open-sans/600.css";  // 600
import "@fontsource/open-sans/700.css";  // 700

// Source Code Pro (replaces fonts.googleapis.com Source Code Pro link)
import "@fontsource/source-code-pro";          // 400
import "@fontsource/source-code-pro/700.css";  // 700

// Material Symbols Outlined (replaces fonts.googleapis.com Material Symbols link)
import "@fontsource/material-symbols-outlined/400.css";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./context/ThemeProvider";
import { ApiProvider } from "./api";

// Suppress harmless ResizeObserver loop warning (fires when observation callback
// triggers a layout change within the same frame — not an actual error)
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ApiProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ApiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
